<h4 style="font-weight: bold; margin-top: 0px">{{ modalTitle || 'Insect Only' }}</h4>
<div class="grid">
  <div class="col-6">
    <app-poc-insect-item
      [distinctInsects]="distinctInsects"
      [distinctGrowthStages]="distinctGrowthStages"
      [distinctInsectVariants]="distinctInsectVariants"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      [idMaps]="idMaps"
      (insectItemChangeEvent)="onReceiveInsectData($event)">
    </app-poc-insect-item>
  </div>

  <!-- [catalogInformation]="catalogInformation"
      [editingOrderItemInsectVariant]="editingOrderItemInsectVariant"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      (insectItemChangeEvent)="onReceiveInsectData($event)" -->

  <div class="col-6">
    <app-poc-container-infestation-rate
      [isDisabled]="containerDisabled"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      [distinctContainers]="distinctContainers"></app-poc-container-infestation-rate>

    <!-- [isDisabled]="containerDisabled"
      [catalogInformation]="catalogInformation"
      [selectedCatalogInsectGrowthStageId]="selectedCatalogInsectGrowthStageId"
      [editingOrderItemContainerInfestation]="editingOrderItemContainerInfestation"
      [editingInstance]="editingInstance"
      [editingMode]="editingMode"
      [reset]="insectInfestationReset"
      (containerItemChangeEvent)="onReceiveContainerData($event)" -->
  </div>
</div>
<div class="grid mt-2">
  <div class="col-6">
    <div class="flex align-content-center flex-wrap">
      <!-- <div class="flex align-items-center justify-content-center mr-2" *ngIf="!editingInstance || (editingInstance && editingMode === 'single')">
        <p-floatlabel variant="on">
          <p-datepicker
            class="required"
            id="deliveryDate"
            [(ngModel)]="orderInsect.deliveryDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            showIcon
            iconDisplay="input"
            data-testId="deliveryDate"
            appendTo="body"
            [disabledDates]="unavailableDates"
            [disabledDays]="invalidDays"
            [disabled]="
              !insectGrowthStageSelected ||
              (!editingInstance && selectedDates && selectedDates.length > 1) ||
              (editingInstance && editingMode === 'future' && selectedDates && selectedDates.length > 1)
            "
            (onSelect)="onDeliveryDateChange()"
            (onInput)="onDeliveryDateChange()"></p-datepicker>
          <label for="on_label">Delivery Date</label>
        </p-floatlabel>
      </div>
      <div *ngIf="showRecurringDatesTooltip" class="flex align-items-center justify-content-center">
        <span
          class="pi pi-info-circle mr-1"
          pTooltip="{{ recurringDatesTooltip }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          style="font-size: 1.2em; cursor: pointer">
        </span>
      </div>
      <div *ngIf="showMakeRecurringButton" class="flex align-items-center justify-content-center">
        <p-button
          [label]="status === 'Updated' || status === 'Approved' ? 'Reschedule Recurrences' : 'Make Recurring'"
          icon="pi pi-sync"
          severity="primary"
          [raised]="true"
          (click)="openMakeRecurringDialog()"
          data-testid="makeRecurring"
          [disabled]="!insectGrowthStageSelected" />
      </div> -->
    </div>
  </div>
  <div class="col-6" *ngIf="!editingInstance">
    <p-floatlabel variant="on">
      <p-select
        #projectSelect
        appLockInitialWidth
        fluid="true"
        [options]="projects"
        [(ngModel)]="orderInsect.projectId"
        data-testid="project"
        optionLabel="name"
        optionValue="projectId"
        filter="true"
        appendTo="body"
        pTooltip="{{ projectTooltipText }}"
        tooltipPosition="right"
        tooltipStyleClass="custom-tooltip"
        filterPlaceholder="Search Project"></p-select>
      <label for="on_label">Project</label>
    </p-floatlabel>
  </div>
</div>
<div class="grid mt-1">
  <div class="col-12">
    <p-floatlabel variant="on">
      <textarea pTextarea data-testid="note" [(ngModel)]="orderInsect.note" rows="8" style="resize: none" class="w-full h-full"></textarea>
      <label for="on_label">Notes</label>
    </p-floatlabel>
  </div>
</div>
<div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
  <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancel()" data-testid="newItemCancel" />
  <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveOrderItem()" data-testid="newItemSave" />
  <!-- <p-button
    *ngIf="!showAddButton"
    label="Save"
    icon="fa fa-check"
    severity="success"
    size="small"
    [raised]="true"
    (click)="onEditSaveOrderItem()"
    data-testid="newItemSave"
    [disabled]="!isInsectFormValid" /> -->
</div>

<app-processing [visible]="isProcessing"></app-processing>
